/* eslint-disable no-use-before-define */

import { FormFieldArrays, SearchParamArrays } from './form-field-arrays'
import { cleanObject, arrayFrom, isEmpty, getConfig } from '../../twd'

export default ({searchParams={}, invType} = {}) => {

    if (invType && !searchParams.holdInvType)  {
        searchParams.holdInvType = [invType]
    }

    let defaultState = getConfig('account_states.0.stateOfResidence','')
    let values = Object.assign({
        muniStates: defaultState && !searchParams.holdState ? ['holdState=' + defaultState] : [],
        cdBlueSky: defaultState  && !searchParams.holdBlueSkyStateCD ? ['holdBlueSkyStateCD=' + defaultState] : [],
    }, initialValues, searchParams)

    values.holdInvType = arrayFrom(values.holdInvType)
        .filter(a => validInvTypes.indexOf(a)>=0)

    values.issuer = arrayFrom(values.holdIssue).map(a => a.trim()).filter(Boolean).join()
    values.cusip = arrayFrom(values.holdCusip).map(a => a.trim()).filter(Boolean).join()

    values.holdSymbol = arrayFrom(values.holdSymbol)[0] || ''

    let holdInvType = values.holdInvType[0]
    if (holdInvType==='C' && values.isEdit) {
        delete values.corpMarketTypes
    }

    values.holdRatingAndOr = values.holdRatingAndOr!=='AND'

    for (let k in FormFieldArrays) {
        let arr = FormFieldArrays[k]
            .map(a => a.value)
            .filter(a => hasParam(searchParams, a))
        if (!isEmpty(arr)) {
            values[k] = arr
        }
    }

    SearchParamArrays.forEach(k => {
        delete values[k]
    })

    if (holdInvType!=='C') {
        values.corpMarketTypes = ['primarySecondary=secondary']
    }
    if (holdInvType!=='S') {
        values.cdMarketTypes = ['primarySecondary=primary']
    }

    if (searchParams.sort) {
        let a = arrayFrom(searchParams.sort)[0] || {}
        values.sortBy = a.field || 'holdMaturitySortDt'
        values.sortOrder = SORT_ORDERS[a.direction] || 'Ascending'
    }

    if (searchParams.offeringNewToday) {
        values.offeringPosted = 'New Today'
    }

    delete values.isEdit

    return cleanObject(values)
}

const hasParam = (searchParams, s) => {
    let [k,v] = s.split('=')
    let arr = searchParams[k]
    return arr && Array.isArray(arr) && arr.indexOf(v)>=0
}

const SORT_ORDERS = {
    'ASC': 'Ascending',
    'DESC': 'Descending'
}

const validInvTypes = ['C', 'M', 'S', 'T', 'A']

export const initialValues = {
    holdInvType: ['C'],
    issuer: '',
    cusip: '',
    corpMarketTypes: ['primarySecondary=secondary'],
    cdMarketTypes: ['primarySecondary=primary'],

    offeringPosted: 'Any Time',
    sortBy: 'holdMaturitySortDt',
    sortOrder: 'Ascending',
    resultsPerPage: 50,

    holdSpRatingMin:'BBB-',
    holdSpRatingMax:'AAA',
    holdMoodyRatingMin:'Baa3',
    holdMoodyRatingMax:'Aaa',
    rating:'investment-grade',
    holdRatingAndOr: 'OR',

    holdMaturityMin:'',
    holdMaturityMax:'',
    clientPriceMin:'',
    clientPriceMax:'',
    quantityMin:'',
    quantityMax:'',
    offerYtwMin:'',
    offerYtwMax:'',
    offerYtmMin:'',
    offerYtmMax:'',
    holdCouponMin:'',
    holdCouponMax:'',
    holdFirstCallMin:'',
    holdFirstCallMax:'',
}


// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/from-search-params.js